"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_2 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var StyledDropdownButton_1 = __importDefault(require("containers/TableMaker/components/StyledDropdownButton"));
var Divider_1 = __importDefault(require("shared/components/Divider"));
var DropdownMenu_1 = __importDefault(require("shared/components/DropdownMenu"));
var DropdownOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownOption"));
var single_1 = require("utils/selectors/single");
var constants_1 = require("../constants");
var hooks_1 = require("../hooks");
var AccessLevelDropdown = function (_a) {
    var _b, _c;
    var item = _a.item;
    var _d = __read(react_2.default.useState(null), 2), anchorEl = _d[0], setAnchorEl = _d[1];
    var _e = __read((0, hooks_1.useUpdateUser)(item.id), 2), userSubmitter = _e[0], isSubmitting = _e[1];
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var companyId = profile.companyId;
    if (!companyId) {
        return null;
    }
    var currentAccLvl = (_b = item.companyAccessLevel) === null || _b === void 0 ? void 0 : _b[companyId];
    var handleClick = function (event) { return setAnchorEl(anchorEl ? null : event.currentTarget); };
    var handleOnClose = function () { return setAnchorEl(null); };
    var allDisabled = item.id === profile.id || (currentAccLvl && !(0, end2end_1.userCan)(currentAccLvl)(profile));
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StyledDropdownButton_1.default, __assign({ onClick: handleClick, isOpen: !!anchorEl }, { children: (_c = constants_1.ACC_LVL_PROPS_MAPPER[currentAccLvl || '']) === null || _c === void 0 ? void 0 : _c.title })), (0, jsx_runtime_1.jsxs)(DropdownMenu_1.default, __assign({ anchorEl: anchorEl, open: !!anchorEl, onClose: handleOnClose }, { children: [constants_1.ACCESS_LEVELS.filter(function (accessLevel) { return (0, end2end_1.userCan)(accessLevel)(profile); }).map(function (accessLevel, index) { return ((0, react_1.createElement)(DropdownOption_1.default, __assign({}, constants_1.ACC_LVL_PROPS_MAPPER[accessLevel], { key: accessLevel, onClick: function () {
                            var _a;
                            return userSubmitter({ companyAccessLevel: (_a = {}, _a[companyId] = accessLevel, _a) });
                        }, disabled: isSubmitting || !!allDisabled, selected: accessLevel === currentAccLvl, autoFocus: index === 0 }))); }), (0, jsx_runtime_1.jsx)(Divider_1.default, {}), (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Suspend User", titleColor: "red", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, userSubmitter({ isSuspended: true })];
                                    case 1:
                                        _a.sent();
                                        handleOnClose();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, disabled: isSubmitting || !!allDisabled || (item.isAccountant && item.companyIds.length > 1) })] }))] }));
};
exports.default = AccessLevelDropdown;
